import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_dialog_actions = _resolveComponent("ontos-dialog-actions")!
  const _component_ontos_instance_create = _resolveComponent("ontos-instance-create")!
  const _component_ontos_dialog = _resolveComponent("ontos-dialog")!

  return (_openBlock(), _createBlock(_component_ontos_dialog, {
    "model-value": true,
    fullscreen: _ctx.$vuetify.display.smAndDown,
    "max-width": "960px",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ontos_instance_create, {
        context: _ctx.context,
        "initial-name": _ctx.initialName,
        "initial-values": _ctx.initialValues,
        "fixed-values": _ctx.fixedValues,
        known: _ctx.known,
        deferred: _ctx.deferred,
        "omit-properties": _ctx.omitProperties,
        onSaved: _ctx.onSaved,
        onPending: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('pending', $event))),
        onShowMessage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('showMessage', $event))),
        onShowErrorMessage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
      }, {
        controls: _withCtx(({dirty}) => [
          _createVNode(_component_ontos_dialog_actions, {
            "full-page-route": _ctx.fullPageRoute,
            dirty: dirty,
            onClosed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closed')))
          }, null, 8, ["full-page-route", "dirty"])
        ]),
        _: 1
      }, 8, ["context", "initial-name", "initial-values", "fixed-values", "known", "deferred", "omit-properties", "onSaved"])
    ]),
    _: 1
  }, 8, ["fullscreen"]))
}